import {
  AlertTriangle,
  BadgeAlert,
  BadgeCheck,
  Info,
  BarChart,
  BarChart3,
  BookOpen,
  Calendar,
  CalendarDays,
  ChartColumnIncreasing,
  ChartGantt,
  ChartLine,
  ChartNoAxesGantt,
  ChartPie,
  ChartScatter,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowDown,
  ArrowDownLeft,
  ArrowLeftRight,
  ArrowRightLeft,
  Ban,
  ArrowUpRight,
  AArrowDown,
  AArrowUp,
  AlignVerticalJustifyCenter,
  AlignVerticalJustifyEnd,
  AlignVerticalJustifyStart,
  Calculator,
  Camera,
  ChartColumn,
  Check,
  CheckCircle,
  CircleAlert,
  CircleArrowDown,
  CirclePlus,
  CircleX,
  Clipboard,
  ClipboardList,
  ClipboardPenLine,
  ClipboardPlus,
  Clock,
  ClockArrowLeft,
  ClockArrowRight,
  Cloud,
  Copy,
  Crosshair,
  DollarSign,
  EllipsisVertical,
  Eraser,
  ExternalLink,
  Eye,
  EyeOff,
  File,
  FileCheck,
  FilePlus2,
  FileChartColumn,
  FileChartColumnIncreasing,
  Files,
  FileSearchCorner,
  FileSearch,
  FileSpreadsheet,
  FileText,
  Folder,
  FolderArchive,
  Funnel,
  Globe,
  HandMetal,
  Headset,
  Hourglass,
  House,
  LineChart,
  Link,
  Link2,
  List,
  ListFilterPlus,
  ListOrdered,
  ListTodo,
  LocateFixed,
  LogOut,
  MessageSquare,
  MessageSquareMore,
  MessageSquareText,
  MessagesSquare,
  SlidersHorizontal,
  Zap,
  Minus,
  Monitor,
  Network,
  NotebookPen,
  Package,
  PanelBottomClose,
  PanelTopClose,
  Paintbrush,
  Pencil,
  PencilRuler,
  Play,
  Plus,
  RefreshCw,
  Repeat,
  RotateCcw,
  Settings,
  ShieldUser,
  SquareCheck,
  Square,
  SquareX,
  Star,
  Table,
  Target,
  TextAlignCenter,
  TextAlignEnd,
  TextAlignStart,
  Thermometer,
  ThumbsUp,
  ThumbsDown,
  ToolCase,
  Trash2,
  TrendingUp,
  TrendingDown,
  TriangleAlert,
  Truck,
  Undo2,
  Unlink,
  User,
  UserCheck,
  UserMinus,
  UserPlus,
  UserRoundMinus,
  UserRoundX,
  UsersRound,
  UserStar,
  Wrench,
  ArrowUpDown,
  ChevronDown,
  ChevronLeft,
  ChevronsDown,
  ChevronsLeft,
  ChevronsUp,
  ChevronRight,
  ChevronUp,
  Columns3,
  Ellipsis,
  Filter,
  GripVertical,
  Download,
  HandCoins,
  KeyRound,
  Lightbulb,
  Mail,
  Menu,
  Pause,
  Save,
  Send,
  X,
  XCircle,
  Search,
  Paperclip,
  Triangle,
  Upload,
  Users,
  ChartNoAxesCombined,
  SquareArrowRightExit,
  LoaderCircle,
  CircleCheck,
  Circle,
  SquarePlus,
  SquarePen,
  Cog,
  Hash,
  Award,
  Heart,
  MessageCircle,
  CircleQuestionMark,
  Bell,
  History,
  Image,
  Share2,
  WrapText,
  Maximize,
  Maximize2,
  Minimize,
  Minimize2,
  ChevronsRight,
  Lock,
  Tag,
  ListPlus,
  Gauge,
  Crop,
  Smile,
} from 'lucide-react';

const TriangleFilled = (props) => (
  <Triangle {...props} fill="currentColor" strokeWidth={0} />
);

const StarFilled = (props) => (
  <Star {...props} fill="currentColor" strokeWidth={0} />
);

const CircleFilled = (props) => (
  <Circle {...props} fill="currentColor" strokeWidth={0} />
);

const SquareFilled = (props) => (
  <Square {...props} fill="currentColor" strokeWidth={0} />
);

const FunnelFilled = (props) => (
  <Funnel {...props} fill="currentColor" strokeWidth={0} />
);

const HeartFilled = (props) => (
  <Heart {...props} fill="currentColor" strokeWidth={0} />
);

const ExclamationMark = ({ size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M12 5v9"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <circle cx="12" cy="18" r="1.5" fill="currentColor" />
  </svg>
);
ExclamationMark.displayName = 'ExclamationMark';

export const iconsDefinitions = {
  AlertTriangle,
  BarChart,
  BarChart3,
  BookOpen,
  Calendar,
  BadgeAlert,
  CalendarDays,
  ChartColumnIncreasing,
  ChartPie,
  ChartScatter,
  ClipboardList,
  ClipboardPenLine,
  ClipboardPlus,
  Crosshair,
  FileSearchCorner,
  FileSearch,
  FileText,
  Headset,
  House,
  ListTodo,
  LocateFixed,
  MessageSquare,
  MessageSquareMore,
  MessageSquareText,
  MessagesSquare,
  NotebookPen,
  SlidersHorizontal,
  Zap,
  Repeat,
  Settings,
  Settings2: Settings,
  Star,
  Thermometer,
  ThumbsUp,
  ThumbsDown,
  Table,
  Target,
  ToolCase,
  Trash2,
  TrendingUp,
  TriangleAlert,
  Unlink,
  User,
  UserMinus,
  UserPlus,
  UserStar,
  Wrench,
  ChartGantt,
  ChartLine,
  ChartNoAxesGantt,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowDown,
  ArrowRightLeft,
  Ban,
  Calculator,
  ChartColumn,
  Check,
  CheckCircle,
  CircleAlert,
  CirclePlus,
  CircleX,
  Clipboard,
  Copy,
  EllipsisVertical,
  ExternalLink,
  Eye,
  FilePlus2,
  FileChartColumn,
  FileChartColumnIncreasing,
  Files,
  FileSpreadsheet,
  Folder,
  FolderArchive,
  Funnel,
  LineChart,
  Link,
  Link2,
  List,
  ListOrdered,
  'message-square': MessageSquare,
  Minus,
  Monitor,
  Network,
  Pencil,
  Play,
  Plus,
  RefreshCw,
  ArrowUpDown,
  Mail,
  Menu,
  ChevronDown,
  ChevronsDown,
  ChevronsUp,
  ChevronRight,
  ChevronUp,
  Columns3,
  Ellipsis,
  Filter,
  GripVertical,
  Download,
  HandCoins,
  KeyRound,
  Lightbulb,
  X,
  Search,
  XCircle,
  Info,
  Paperclip,
  Pause,
  Save,
  Send,
  Upload,
  Users,
  'account-group': Users,
  'alert-circle-outline': CircleAlert,
  'alert-outline': TriangleAlert,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-up': ArrowUp,
  'arrow-down': ArrowDown,
  'badge-alert': BadgeAlert,
  'calendar-days': CalendarDays,
  calculator: Calculator,
  'chart-bar': ChartColumn,
  'chart-line-variant': ChartLine,
  'chart-line': ChartLine,
  flash: Zap,
  'flash-outline': Zap,
  'calendar-multiple': CalendarDays,
  'calendar-blank': Calendar,
  speedometer: Gauge,
  'bell-outline': Bell,
  'bank-transfer': ArrowRightLeft,
  'bank-transfer-in': ArrowDownLeft,
  'bank-transfer-out': ArrowUpRight,
  'star-outline': Star,
  import: Download,
  crop: Crop,
  'alert-circle': CircleAlert,
  'plus-box': SquarePlus,
  'chart-column-increasing': ChartColumnIncreasing,
  'chart-pie': ChartPie,
  'chart-scatter': ChartScatter,
  'chevron-double-down': ChevronsDown,
  'chevron-double-up': ChevronsUp,
  'clipboard-list': ClipboardList,
  'clipboard-pen-line': ClipboardPenLine,
  'clipboard-plus': ClipboardPlus,
  clap: HandMetal,
  'clipboard-text': ClipboardList,
  'clipboard-text-outline': ClipboardList,
  close: X,
  'close-box': SquareX,
  'close-circle': XCircle,
  'close-circle-outline': XCircle,
  'content-save-outline': Save,
  'content-sav-outline': Save,
  crosshair: Crosshair,
  delete: Trash2,
  'delete-outline': Trash2,
  'delete-sweep-outline': Eraser,
  download: Download,
  eraser: Eraser,
  camera: Camera,
  certificate: Award,
  attachment: Paperclip,
  'file-document-outline': FileText,
  'file-document-check-outline': FileCheck,
  'file-chart-outline': FileChartColumn,
  'file-chart-check-outline': FileChartColumnIncreasing,
  'file-outline': FileText,
  'image-outline': Image,
  export: Share2,
  cog: Cog,
  'account-outline': User,
  account: User,
  'account-multiple-minus': UserRoundMinus,
  'account-off': UserRoundX,
  'account-plus-outline': UserPlus,
  'account-multiple-outline': Users,
  'account-box-multiple': UsersRound,
  'account-multiple': Users,
  'message-outline': MessageSquare,
  'table-plus': ListPlus,
  'block-helper': Ban,
  lock: Lock,
  'label-outline': Tag,
  tag: Tag,
  circle: CircleFilled,
  email: Mail,
  'eye-outline': Eye,
  'eye-off-outline': EyeOff,
  eye: Eye,
  'file-excel': FileSpreadsheet,
  'file-pdf-box': FileText,
  file: File,
  'file-download-outline': Download,
  'file-upload-outline': Upload,
  'file-search-corner': FileSearchCorner,
  'file-text': FileText,
  filter: Filter,
  'filter-outline': Filter,
  'filter-plus-outline': ListFilterPlus,
  'dots-vertical': EllipsisVertical,
  'dots-horizontal': Ellipsis,
  'format-columns': Columns3,
  'format-paint': Paintbrush,
  'format-align-center': TextAlignCenter,
  'format-align-left': TextAlignStart,
  'format-align-right': TextAlignEnd,
  'format-font-size-decrease': AArrowDown,
  'format-font-size-increase': AArrowUp,
  'format-list-numbered': ListOrdered,
  'format-vertical-align-bottom': AlignVerticalJustifyEnd,
  'format-vertical-align-center': AlignVerticalJustifyCenter,
  'format-vertical-align-top': AlignVerticalJustifyStart,
  'clock-outline': Clock,
  'email-outline': Mail,
  'arrow-down-bold-circle-outline': CircleArrowDown,
  'arrow-left-right': ArrowLeftRight,
  'arrow-expand': Maximize,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  'chevron-double-right': ChevronsRight,
  'chevron-double-left': ChevronsLeft,
  'page-first': ChevronsLeft,
  'page-last': ChevronsRight,
  link: Link,
  'link-2': Link2,
  unlink: Unlink,
  web: Globe,
  poll: BarChart,
  'message-draw': SquarePen,
  'folder-archive': FolderArchive,
  'folder-outline': Folder,
  alert: TriangleAlert,
  'content-copy': Copy,
  'content-paste': Clipboard,
  history: History,
  'chart-gantt': ChartGantt,
  'lock-outline': Lock,
  'checkbox-marked-circle-outline': CircleCheck,
  'check-circle-outline': CircleCheck,
  'checkbox-blank': SquareFilled,
  'checkbox-blank-outline': Square,
  'check-decagram-outline': BadgeCheck,
  'information-outline': Info,
  information: Info,
  exclamation: ExclamationMark,
  calendar: Calendar,
  'clock-start': ClockArrowRight,
  'clock-end': ClockArrowLeft,
  numeric: Hash,
  check: Check,
  cancel: X,
  'checkbox-marked-outline': SquareCheck,
  'close-box-outline': XCircle,
  'comment-text-outline': MessageSquareText,
  'coment-text-outline': MessageSquareText,
  'comment-multiple': MessagesSquare,
  'format-list-bulleted': List,
  'hand-coin-outline': HandCoins,
  house: House,
  'list-todo': ListTodo,
  'locate-fixed': LocateFixed,
  'lock-reset': KeyRound,
  'lightbulb-outline': Lightbulb,
  magnify: Search,
  menu: Menu,
  'message-square-more': MessageSquareMore,
  'notebook-pen': NotebookPen,
  'open-in-new': ExternalLink,
  'playlist-edit': ClipboardPenLine,
  pause: Pause,
  pencil: Pencil,
  'pencil-ruler': PencilRuler,
  play: Play,
  plus: Plus,
  minus: Minus,
  'plus-circle': CirclePlus,
  'plus-circle-outline': CirclePlus,
  refresh: RefreshCw,
  restart: RotateCcw,
  repeat: Repeat,
  send: Send,
  settings: Settings,
  'settings-2': Settings,
  'shield-account': ShieldUser,
  sitemap: Network,
  sort: ArrowUpDown,
  'arrow-up-down': ArrowUpDown,
  star: StarFilled,
  sync: RefreshCw,
  'timer-sand': Hourglass,
  target: Target,
  'bullseye-arrow': Target,
  thermometer: Thermometer,
  'tool-case': ToolCase,
  'panel-bottom-close': PanelBottomClose,
  'panel-top-close': PanelTopClose,
  transfer: ArrowRightLeft,
  undo: Undo2,
  'trending-up': TrendingUp,
  'trending-down': TrendingDown,
  'triangle-alert': TriangleAlert,
  upload: Upload,
  'view-list': List,
  logout: LogOut,
  user: User,
  'user-plus': UserPlus,
  'user-star': UserStar,
  wrench: Wrench,
  triangle: TriangleFilled,
  ChartNoAxesCombined,
  'file-chart-column-increasing': FileChartColumnIncreasing,
  'file-search': FileSearch,
  'file-plus-2': FilePlus2,
  SquareArrowRightExit,
  LoaderCircle,
  CircleCheck,
  Circle,
  StarFilled: StarFilled,
  CircleFilled: CircleFilled,
  FunnelFilled,
  SquarePlus,
  SquarePen,
  Heart,
  HeartFilled,
  MessageCircle,
  Cog,
  CircleQuestionMark,
  Bell,
  Clock,
  Cloud,
  DollarSign,
  Package,
  SquareCheck,
  Truck,
  UserCheck,
  Hash,
  Award,
  'square-pen': SquarePen,
  'trash-2': Trash2,
  autorenew: RefreshCw,
  tune: SlidersHorizontal,
  History,
  WrapText,
  wrap: WrapText,
  Maximize,
  'maximize-2': Maximize2,
  Minimize,
  'minimize-2': Minimize2,
  Lock,
  ChevronsRight,
  Tag,
  ListPlus,
  'unfold-more-horizontal': ArrowUpDown,
  drag: GripVertical,
  Smile,
};

export const getIconsDefinitions = (icon) => iconsDefinitions[icon] || null;
